module.exports = __webpack_public_path__ + "static/img/2.b28800b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/2.png
// module id = TuFB
// module chunks = 0